<template>
  <div class="dealer_manage_add_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="saveSuite">保存</el-button>
    </div>
    <div class="dealer_manage_box" :style="`height: ${windowHeight - 180}px;`">
      <div class="dealer_manage_content">
        <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="经销商名称" prop="bussinessName">
            <el-input v-model="formData.bussinessName" :minlength="1" :maxlength="15" placeholder="1~15位中文、英文或其组合"></el-input>
          </el-form-item>
          <el-form-item label="经销商编号" prop="bussinessNumber">
            <el-input v-model="formData.bussinessNumber" :minlength="1" :maxlength="15" placeholder="1~15位中文、英文或其组合"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="managerName">
            <el-input v-model="formData.managerName" :minlength="1" :maxlength="15" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="managerMobile">
            <el-input v-model.trim="formData.managerMobile" :maxlength="11" placeholder="11位有效手机号" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize'
  import {queryDealer, insertDealer, updateDealer} from '@/api/dealerManage'

  export default {
    name: "dealerManageAdd",
    data() {
      const checkMobile = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号码不能为空！'));
        }
        const g = /^0?1[345789][0-9]\d{8}$/;
        if (!g.test(value)) {
          callback(new Error('手机号码格式不正确！'));
        } else {
          callback();
        }
      };
      return {
        dealerId: this.$route.query.dealerId,
        formData: {
          bussinessName: '',
          bussinessNumber: '',
          managerName: '',
          managerMobile: ''
        },
        rules: {
          bussinessName: [
            {required: true, trigger: 'blur', message: '请输入经销商名称'},
            {min: 1, max: 15, message: "请输入1~15位中文、英文或其组合", trigger: "change"}
          ],
          bussinessNumber: [
            {required: true, trigger: 'blur', message: '请输入经销商编号'},
            {min: 1, max: 15, message: "请输入1~15位中文、英文或其组合", trigger: "change"}
          ],
          managerName: [
            {required: true, trigger: 'blur', message: '请输入联系人'},
            {min: 1, max: 15, message: "请输入联系人", trigger: "change"}
          ],
          managerMobile: [
            {required: true, validator: checkMobile, trigger: 'blur'}
          ]
        }
      }
    },
    mixins: [windowResize],
    created() {
      if (this.dealerId) this.queryDealer();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      queryDealer() {
        queryDealer({id: this.dealerId}).then(data => {
          this.formData = {
            bussinessName: data.bussinessName,
            bussinessNumber: data.bussinessNumber,
            managerName: data.managerName,
            managerMobile: data.managerMobile
          };
        })
      },
      saveSuite() {
        this.$refs.form.validate(isValid => {
          if (isValid) {
            new Promise(resolve => {
              if (this.dealerId) {
                this.formData.id = this.dealerId;
                updateDealer(this.formData).then(resolve)
              } else {
                insertDealer(this.formData).then(resolve)
              }
            }).then(() => {
              this.$message.success(`${this.dealerId ? '编辑' : '新增'}成功`);
              window.setTimeout(() => {
                this.goBack();
              }, 500);
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .dealer_manage_add_wrap {
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .dealer_manage_box {
      @include scrollBar;

      .dealer_manage_content {
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/dealerManage/dealer/dealerManageAdd.vue